import {on} from './event';
import url from './url';

const changeEventName = 'change.kiosk.urlParams';

on(changeEventName, function (e: any) {
    const data = e.detail;
    // TODO check is data = {name: value, name2: value2}
    url.setParams(data);
});


const urlParams = {
    changeEventName: changeEventName
};

export default urlParams;
